<style>
.container-mis-rep {
  display: flex;
  justify-content: center;
  height: 100%;
  padding: 20px;
}

.centered-content-mis-rep {
  padding: 20px;
  /*background-color: #f0f0f0;
  border: 1px solid #ccc;
  border-radius: 8px;*/
  width: 100%;
  max-width: 250px;
  box-sizing: border-box;
}
</style>

<template>
  <div>
    <base-header type class="rsgradient pb-3 pb-1 pt-3 pt-md-5"></base-header>

    <b-card style="margin: 20px">
      <!-- <b-card-header header-tag="header" class="p-1" role="tab"></b-card-header> -->
      <b-card-body>
        <div class="container-mis-rep">
          <div class="centered-content-mis-rep">
            <div style="font-weight:bold; margin-bottom:20px">Seleccione una opción</div>
            <div style="display: flex; align-items: center; gap: 50px; width:600px">
              <div>
                <b-button class="btn btn-success" @click="GoToRecurrencias()">Recurrencias</b-button>
              </div>
            </div>
            <div
              style="margin-top: 10px; display: flex; align-items: center; gap: 50px; width:600px"
            >
              <div>
                <b-button class="btn btn-success" @click="GoToDebinRecurrente()">Debines</b-button>
              </div>
            </div>
          </div>
        </div>
      </b-card-body>
    </b-card>
  </div>
</template>

<script>
import axiosHelpers from "@/helpers/axiosHelpers";
import ResimpleSwitch from "@/components/Custom/ResimpleSwitch";

export default {
  components: { "resimple-switch": ResimpleSwitch },
  data() {
    return {};
  },
  methods: {
    GoToRecurrencias() {
      let context = this;

      context.$router.push({
        name: "Recurrencias"
      });
    },
    GoToDebinRecurrente() {
      let context = this;

      context.$router.push({
        name: "DebinRecurrente"
      });
    }
  }
};
</script>